<ng-container *ngIf="tyreDefaults && tyreDefaults[0]?.tyre_type && tyreDefaults.length > 0; else noTyreDefaultsBlock">
  {{ 'tyre-types.' + tyreDefaults[0].tyre_type?.id | translate }}
</ng-container>

<ng-template #noTyreDefaultsBlock> - </ng-template>
